import { render, staticRenderFns } from "./MultiSelectNew.vue?vue&type=template&id=bbe25eb4&scoped=true&"
import script from "./MultiSelectNew.vue?vue&type=script&lang=js&"
export * from "./MultiSelectNew.vue?vue&type=script&lang=js&"
import style0 from "./MultiSelectNew.vue?vue&type=style&index=0&id=bbe25eb4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe25eb4",
  null
  
)

export default component.exports